import request from '../utils/request'

export function municipality() {
    return request({
        url: 'anexo/municipios',
        method: 'get'
    })
}

export function contries() {
    return request({
        url: 'anexo/paises',
        method: 'get'
    })
}

export function technical() {
    return request({
        url: 'anexo/tecnico',
        method: 'get'
    })
}
